// extracted by mini-css-extract-plugin
module.exports = {"endScreenMessage":"Survey_endScreenMessage__dQ57G"};